// extracted by mini-css-extract-plugin
export default {"wrapper":"OutstaffAnother_wrapper__z-wP7","title":"OutstaffAnother_title__9J4KM","container":"OutstaffAnother_container__S0-is"};